import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/dashboard/progress";

export const Route = createFileRoute("/dashboard/progress")({
  component: Page,
});
